import axios from "axios";
import { API_BASE } from "../../config/env";
/**APPLICATION START */
export const FETCH_TARGETINSTITUTIONDETAIL_FULFILLED = "FETCH_TARGETINSTITUTIONDETAIL_FULFILLED";
export const FETCH_TARGETINSTITUTIONDETAIL_REJECTED = "FETCH_TARGETINSTITUTIONDETAIL_REJECTED";
export const FETCH_TARGETINSTITUTIONDETAIL_PENDING = "FETCH_TARGETINSTITUTIONDETAIL_PENDING";
export const RESET_TARGETINSTITUTIONDETAIL = "RESET_TARGETINSTITUTIONDETAIL"


export function targetInstitutionDetail() {

    const token = localStorage.getItem("accessToken")

    return (dispatch) => {
        dispatch({
            type: "FETCH_TARGETINSTITUTIONDETAIL",
            payload: axios({
                method: "GET",
                url: `${API_BASE}/api/v3/second-opinion/target-institution-detail`,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("One-Id"),
                    "One-Id": localStorage.getItem("Client-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning" : "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function resetTargetInstitutionDetail() {
    return (dispatch) => {
        dispatch({
            type: "RESET_TARGETINSTITUTIONDETAIL",
        });
    };
}


